// Helpers for the daily movement window.
//
// The API returns one flat field per day per metric (salesThreeDaysAgo,
// mermaThreeDaysAgo, receivingThreeDaysAgo, ...) rather than an array, so these
// rebuild an ordered series from those names. Doing it once here is what lets
// the table drop ~700 lines of copy-pasted per-day column definitions.

// Oldest first, so the sparkline reads left-to-right in time order.
export const DAY_OFFSETS = [7, 6, 5, 4, 3, 2, 1];

const SUFFIX = {
  1: 'OneDayAgo',
  2: 'TwoDaysAgo',
  3: 'ThreeDaysAgo',
  4: 'FourDaysAgo',
  5: 'FiveDaysAgo',
  6: 'SixDaysAgo',
  7: 'SevenDaysAgo',
};

export const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export const fieldFor = (metric, offset) => `${metric}${SUFFIX[offset]}`;

// metric is 'sales' | 'merma' | 'receiving'
export const daySeries = (row, metric) =>
  DAY_OFFSETS.map((offset) => num(row?.[fieldFor(metric, offset)]));

export const sumSeries = (values) => values.reduce((a, b) => a + b, 0);

export const averageSeries = (values) =>
  (values.length ? sumSeries(values) / values.length : 0);
